class MatchedColumnHeight extends HTMLElement {
  constructor() {
    super();
    this.targetColumn = null;
    this.referenceColumn = null;
    this.initialHeight = null;
    this.resizeObserver = null;
    this.isInitialized = false;
    this.extraHeight = 0;
  }

  connectedCallback() {
    // Récupérer les sélecteurs depuis les attributs data
    const targetSelector = this.dataset.targetColumn;
    const referenceSelector = this.dataset.referenceColumn;
    this.extraHeight = parseInt(this.dataset.extraHeight || '0', 10);

    if (!targetSelector || !referenceSelector) {
      console.warn('MatchedColumnHeight: data-target-column and data-reference-column attributes are required');
      return;
    }

    this.targetColumn = this.querySelector(targetSelector);
    this.referenceColumn = this.querySelector(referenceSelector);

    if (!this.targetColumn || !this.referenceColumn) {
      console.warn('MatchedColumnHeight: Could not find target or reference column');
      return;
    }

    // Attendre que le DOM soit complètement chargé
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.init());
    } else {
      this.init();
    }
  }

  init() {
    // Attendre que les images soient chargées avant de calculer
    const images = this.targetColumn.querySelectorAll('img');
    let loadedImages = 0;
    const totalImages = images.length;

    if (totalImages === 0) {
      this.setupHeight();
    } else {
      images.forEach(img => {
        if (img.complete) {
          loadedImages++;
          if (loadedImages === totalImages) {
            this.setupHeight();
          }
        } else {
          img.addEventListener('load', () => {
            loadedImages++;
            if (loadedImages === totalImages) {
              this.setupHeight();
            }
          });
        }
      });
    }
  }

  setupHeight() {
    // Calculer et définir la hauteur initiale
    this.setColumnHeight();

    // Observer les changements de taille de la fenêtre
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        // Réinitialiser la hauteur lors du redimensionnement
        this.initialHeight = null;
        this.isInitialized = false;
        this.setColumnHeight();
      }, 250);
    });

    // Empêcher le recalcul lors de changements de contenu dynamiques
    this.preventHeightChangeOnContentToggle();
    
    this.isInitialized = true;
  }

  setColumnHeight() {
    // Ne calculer que sur desktop (min-width: 750px)
    if (window.innerWidth < 750) {
      this.targetColumn.style.height = '';
      this.initialHeight = null;
      return;
    }

    // Attendre un instant pour que le DOM soit stabilisé
    requestAnimationFrame(() => {
      // Calculer la hauteur du contenu de référence
      const referenceHeight = this.referenceColumn.scrollHeight;
      const targetHeight = referenceHeight + this.extraHeight;

      // Appliquer la hauteur à la colonne cible
      this.targetColumn.style.height = `${targetHeight}px`;
      
      // Stocker la hauteur initiale pour éviter les changements
      if (!this.initialHeight || !this.isInitialized) {
        this.initialHeight = targetHeight;
      }
    });
  }

  preventHeightChangeOnContentToggle() {
    // Observer les éléments <details> pour les accordéons
    const details = this.querySelectorAll('details');
    
    details.forEach(detail => {
      detail.addEventListener('toggle', () => {
        // Bloquer le recalcul de la hauteur lors de l'ouverture/fermeture
        if (window.innerWidth >= 750 && this.initialHeight && this.isInitialized) {
          requestAnimationFrame(() => {
            this.targetColumn.style.height = `${this.initialHeight}px`;
          });
        }
      });
    });
  }

  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }
}

customElements.define('matched-column-height', MatchedColumnHeight);
